import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TrackByFunction
} from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { debounceTime, map, shareReplay, takeUntil } from 'rxjs/operators'
import { UntypedFormControl } from '@angular/forms'
import { Observable, Subject } from 'rxjs'
import { CategoryListType, CategoryView } from './category-list.interface'
import { AdComponentInputs } from '../../shared/ads/ad/ad-component.interface'
import { CategoryAvatarData } from '../../singleton-services/category.service.interface'
import { getRouteQueryParams } from 'src/app/singleton-services/category.service.utility'
import { AdTypes } from '../../shared/ads/advertising-service/ad-config'

@Component({
  selector: 'flo-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryListComponent implements OnInit, OnDestroy {
  @Input() public adConfigMap: Map<AdTypes, AdComponentInputs>
  @Input() public type: CategoryListType
  @Input() public categories: ReadonlyArray<CategoryView>
  @Output() public searchChange = new EventEmitter<{ q: string }>()
  @Output() public showMoreCategories = new EventEmitter<void>()

  constructor(private readonly ar: ActivatedRoute) {}

  ngOnInit() {
    this.initSearchBox()
  }

  private readonly ngOnDestroy$ = new Subject<void>()

  public searchForm = new UntypedFormControl(this.ar.snapshot.queryParamMap.get('q') || '')

  public querySearch$: Observable<{ hasSearch: boolean; currentQuery: string }> = this.ar.queryParamMap.pipe(
    map(queryParams => getRouteQueryParams(queryParams)),
    map(params => {
      return {
        hasSearch: !!params.q,
        currentQuery: params.q ? params.q : ''
      }
    }),
    shareReplay(1),
    takeUntil(this.ngOnDestroy$)
  )

  public get pageTitle(): string {
    return `${this.type}s`
  }

  public get searchPlaceholder(): string {
    return `Search for ${this.type}s`
  }

  public trackByCategoryId: TrackByFunction<CategoryAvatarData> = (i: number, item: CategoryAvatarData) => item.id

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next()
    this.ngOnDestroy$.complete()
  }

  public AdComponent = import('../../shared/ads/ad/ad.component').then(m => m.AdComponent)

  private initSearchBox() {
    this.searchForm.valueChanges.pipe(debounceTime(500), takeUntil(this.ngOnDestroy$)).subscribe(query => {
      this.searchChange.next({ q: query })
    })
  }
}
